import { useState } from "react";
import { isAvailableToOrder } from "@/utils/product/isAvailableToOrder";
import {
  hasSocialProofMessages,
  SocialProofMessagesProperties,
} from "../utils/utils";
// Must be used within a standardComponent (requires StandardPropsContext)
import { useStandardProps } from "@/context/StandardPropsContext/StandardPropsContext";

export function useSocialProofMessages(): {
  socialProofMessagesProperties: SocialProofMessagesProperties;
  useNewSocialProofMessagesPosition: boolean;
} {
  const { product, configProps, flags, experiencesRawObject, runtimeConfig } =
    useStandardProps();

  const [showSocialProofMessages, setShowSocialProofMessages] = useState(
    flags?.showSocialProofMessages?.value === true,
  );
  const [fadeOutSocialProofMessages, setFadeOutSocialProofMessages] =
    useState(false);

  const spm = hasSocialProofMessages(configProps)
    ? configProps.SocialProofMessages
    : undefined;
  const socialProofMessagesProperties: SocialProofMessagesProperties =
    product.__typename === "SimpleProduct" && spm
      ? {
          appId: spm.appId ?? "",
          withClose: spm.withClose || true,
          productId: product.aliases.pimProductId,
          brand: product.brand.name,
          availableToOrder: isAvailableToOrder(product),
          experiencesRawObject,
          showSocialProofMessages,
          setShowSocialProofMessages,
          fadeOutSocialProofMessages,
          setFadeOutSocialProofMessages,
          monetateEnvironment: runtimeConfig.monetateEnvironment,
        }
      : undefined;

  const useNewSocialProofMessagesPosition =
    flags?.useNewSocialProofMessagesPosition?.value === true;

  return { socialProofMessagesProperties, useNewSocialProofMessagesPosition };
}
